import React, { useEffect, useState } from 'react';
import GoogleMapReact from 'google-map-react';

import mapStyles from './styles';
import styles from './map-modal.module.css';

import Marker from './Marker';
import Social from '../../layout/footer/social';

import { name } from './Marker';

const defaultProps = {
  center: {
    lat: 59.4323125,
    lng: 24.7488125,
  },
  zoom: 12,
};

export interface IMapModal {
  center: {
    lat: number;
    lng: number;
  };
  zoom?: number;
  location?: keyof typeof name;
}

const MapModal = ({ center, zoom, location }: IMapModal) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(window.innerWidth < 768);
  }, []);

  return (
    <div className={styles.mapContainer}>
      <a href="/" className={styles.logoLink} />
      <Social customStyle={styles.socialLink} />
      <GoogleMapReact
        options={{ styles: mapStyles }}
        bootstrapURLKeys={{ key: process.env.GATSBY_GOOGLE_MAP_KEY }}
        defaultCenter={center || defaultProps.center}
        defaultZoom={zoom || defaultProps.zoom}
        zoom={isMobile ? 12 : 13}
      >
        <Marker lat={center.lat} lng={center.lng} name={location} />
      </GoogleMapReact>
    </div>
  );
};

export default MapModal;
